<script setup lang="ts">
/**
 *
 * @name SuccessModal
 * @author @MrCalamitous
 * @version 1.0.0
 *
 * @description COMPONENTE MODAL QUE PERMITE MOSTRAR UN MODAL DE ÉXITO
 *
 * responsabilidades:
 * R1: PERMITE MOSTRAR UN MODAL DE ÉXITO
 *
 * @changelog 1.0.0 - 2025-06-26 - @MrCalamitous - Versión inicial del componente
 */
import { ref, watch } from 'vue'
import BaseModal from './BaseModal.vue'

const props = defineProps({
	modelValue: {
		type: Boolean,
		required: true
	},
	message: {
		type: String,
		default: 'Operación exitosa'
	}
})

const emit = defineEmits(['update:modelValue'])

const isVisible = ref(props.modelValue)

watch(
	() => props.modelValue,
	newValue => {
		isVisible.value = newValue
	}
)

watch(isVisible, newValue => {
	emit('update:modelValue', newValue)
})

const closeModal = () => {
	isVisible.value = false
}
</script>

<template>
	<BaseModal v-model="isVisible" title="Éxito" :message="message" :testMode="false" size="medium">
		<div class="success-modal">
			<div class="success-icon">
				<i class="fas fa-check-circle"></i>
			</div>
			<div class="message">
				{{ message.trim() || 'Operación exitosa' }}
			</div>
		</div>
		<template #footer>
			<button class="btn btn-primary" @click="closeModal">Aceptar</button>
		</template>
	</BaseModal>
</template>
<style scoped>
.success-modal {
	text-align: center;
	padding: 1rem;
}

.success-icon {
	font-size: 3rem;
	color: #28a745;
	margin-bottom: 1rem;
}

.message {
	font-size: 1.1rem;
	color: #333;
}
</style>
